import { Box, Skeleton } from '@mui/material'

export function MarkdownSkeleton() {
  return (
    <Box aria-label='Markdown skeleton'>
      <Skeleton width='80%' height={24} sx={{ mb: 1 }} />
      <Skeleton width='90%' height={20} sx={{ mb: 0.5 }} />
      <Skeleton width='85%' height={20} sx={{ mb: 0.5 }} />
      <Skeleton width='75%' height={20} />
    </Box>
  )
}
